import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WalkthroughComponent } from './walkthrough.component';
import { TooltipModule } from 'src/app/tooltip-pro';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [WalkthroughComponent],
  imports: [
    CommonModule,
    FormsModule,
    TooltipModule,
  ],
  exports: [
    WalkthroughComponent
  ]
})
export class WalkthroughModule { }
